<template>
  <section>
    <div class="blocked_warning">
      <section class="flex-sb-center">
        <div
          v-if="icon"
          class="icon">
          <font-awesome-icon :icon="icon"></font-awesome-icon>
        </div>
        <div class="content">
          <div class="tips">
            {{text}}
          </div>
        </div>
      </section>
      <v-button
        green
        @click="handleClick">Void Policy</v-button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'VWarning',
  props:{
    text:{
      type:String,
      default:''
    },
    icon:{
      type:String,
      default:''
    }
  },
  data () {
    return {

    }
  },
  computed:{
  },
  methods: {
    handleClick(){
      this.$emit('click')
    }
  },
}
</script>
<style lang='scss' scoped>
.blocked_warning{
  padding: 15px;
  display: flex;
  justify-content: space-between;
  background: #FFE3E6;
  border: 1px solid rgba(158, 28, 35, 0.2);
  border-radius: 6px;
  .icon{
    font-size: 14px;
    color: #CB2431;
  }
  .content{
    margin-left: 15px;
    .tips{
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
    }
    .list{
      margin-top: 15px;
      ul{
        padding-left: 20px;
        li{
          font-weight: 400;
          font-size: 14px;
          color: #24292E;
          line-height: 20px;
          &.list-style__none{
            list-style: none;
          }
        }
      }
    }
  }
}
</style>
